import { divIcon } from 'leaflet';

export const positionIcon = divIcon({
  className: 'custom-user-marker',
  html: `<div class="user-pulse"></div>`,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});

export const itemIcon = divIcon({
  className: 'custom-place-marker',
  html: `
    <div class="place-pin">
      <svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3" fill="#ffffff" stroke="#ffffff"></circle>
      </svg>
    </div>
  `,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
});

export const schoolIcon = divIcon({
  className: 'custom-place-marker school-marker',
  html: `
    <div class="place-pin">
      <svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
        <path d="M6 12v5c3 3 9 3 12 0v-5" fill="none" stroke="#ffffff" stroke-width="2.5"></path>
      </svg>
    </div>
  `,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
});

export const getDynamicIcon = (count: number) => {
  const baseSize = 32;
  const growthFactor = 8;
  const size = baseSize + (count - 1) * growthFactor;
  
  return divIcon({
    className: 'custom-place-marker',
    html: `
      <div class="place-pin" style="width: ${size}px; height: ${size}px;">
        <svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="width: 100%; height: 100%;">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3" fill="#ffffff" stroke="#ffffff"></circle>
        </svg>
        ${count > 1 ? `<span class="badge" style="position: absolute; top: -5px; right: -5px; background: #E74C3C; color: white; border-radius: 50%; min-width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; font-size: ${Math.min(14, 10 + count)}px; font-weight: bold; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.2);">${count}</span>` : ''}
      </div>
    `,
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
  });
};
